import * as types from './users-external-integration-action-types';
import auth from '../../../config/app-specific-config/auth';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { setExternalIntegrationsConfig } from '../../organizations/actions/external-integration-actions';


export const getUserExternalIntegrationsRequest = () => {
	return {
		type: types.GET_USER_EXTERNAL_INTEGRATION_REQUEST
	};
};

export const getUserExternalIntegrationsSuccess = (response) => {
	return {
		type: types.GET_USER_EXTERNAL_INTEGRATION_SUCCESS,
		payload: response.data
	};
};

export const getUserExternalIntegrationsFailure = (error) => {
	return {
		type: types.GET_USER_EXTERNAL_INTEGRATION_FAILURE,
		error
	};
};

export function getUserExternalIntegrations() {
	
	return async (dispatch) => {
		dispatch(getUserExternalIntegrationsRequest());
		try {
			const url = `/integrations/user-config`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.get(url, {
				headers
			});

			if (response.data.data.authorisedExternalIntegrations) {
				dispatch(setExternalIntegrationsConfig(response.data.data.authorisedExternalIntegrations))
			}
	
			dispatch(getUserExternalIntegrationsSuccess(response));

		} catch (error) {
			dispatch(getUserExternalIntegrationsFailure(error));
		}
	};
}